import * as _ from 'lodash';
import { marker as _translate } from '@biesbjerg/ngx-translate-extract-marker';

export enum WarningMessageType {
    Other = 0,
    ImmobilizerBypass = 1,
    SocWarning = 2,
    VehicleDelay = 3,
    NoParkingSpotFound = 5,
    UnknownVehicleCon = 6,
    TripNotStartedWarning = 7,
    OffRouteWarning = 8,
    SignOnMissingWarning = 9
}

export class VehicleWarningMessage {
    message: string;
    culture: number;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}

export class VehicleWarning {
    measuredAt: Date;
    timestamp: Date;
    severityRatio: number;
    messageType: number; // This is intentionally not an enum since we want to be able to support new types without releasing new code.
    warningMessages: VehicleWarningMessage[];
    isActive: boolean;
    metadata: any;
    markedAsStale: boolean;

    public get id(): string {
        if (this.messageType === WarningMessageType.TripNotStartedWarning) {
            return this?.metadata?.messageId || 'unknown';
        } else if (this.messageType === WarningMessageType.OffRouteWarning) {
            return this?.metadata?.messageId || 'unknown';
        } else if (this.messageType === WarningMessageType.SignOnMissingWarning) {
            return this?.metadata?.messageId || 'unknown';
        } else {
            return this.getType();
        }
    }

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }

    public getType(): string {
        return WarningMessageType[this.messageType];
    }
}

export class VehicleConfirmedWarning extends VehicleWarning {
    comment: string;
    confirmedAt: Date;
    confirmedBy: string;
    markedAsStale: boolean;

    public get id(): string {
        if (this.messageType === WarningMessageType.TripNotStartedWarning) {
            return this?.metadata?.messageId || 'unknown';
        } else if (this.messageType === WarningMessageType.OffRouteWarning) {
            return this?.metadata?.messageId || 'unknown';
        } else {
            return this.getType();
        }
    }

    constructor(obj = null) {
        super(obj);

        if (obj) {
            Object.assign(this, obj);
        }
    }

    public getType(): string {
        return WarningMessageType[this.messageType];
    }
}
